import type { SidebarSection } from "~/types/sidebar";

/** Pages de l'espace « Gestion nationale », chacune derrière sa permission. */
export const useGestionSections = () => {
  const hasPermission = usePermission();

  const sections = computed<SidebarSection[]>(() => [
    {
      key: "gestion-meetings",
      titleKey: "label.gestion.section.meetings",
      items: [
        {
          key: "all",
          icon: "layer-group",
          labelKey: "title.meetings.gest",
          to: RouteUtils.gestionnaire,
          visible: hasPermission.value("view_all_meeting"),
        },
        {
          key: "scope",
          icon: "sitemap",
          labelKey: "title.meetings.my-scope",
          to: RouteUtils.gestionnaireMyScope,
          visible: hasPermission.value("view_scope_meeting"),
        },
        {
          key: "ongoing",
          icon: "chart-gantt",
          labelKey: "title.meetings.ongoing",
          to: RouteUtils.gestionnaireOngoing,
          visible:
            hasPermission.value("view_all_meeting") ||
            hasPermission.value("view_scope_meeting"),
        },
        {
          key: "opinion-review",
          icon: "feather",
          labelKey: "title.meetings.opinion-review",
          to: RouteUtils.getMeetingGestionnaireOpinionReview(),
          visible: hasPermission.value("view_scope_meeting"),
        },
        {
          key: "participants-export",
          icon: "file-export",
          labelKey: "title.export.participants",
          to: RouteUtils.getGestionnaireParticipantsExport(),
          visible: hasPermission.value("view_across_meetingparticipant"),
        },
      ],
    },
    {
      key: "gestion-national",
      titleKey: "label.gestion.section.national",
      items: [
        {
          key: "national-documents",
          icon: "folder-open",
          labelKey: "title.national-documents",
          to: RouteUtils.gestionnaireNationalDocuments,
          visible: hasPermission.value("change_template_resource"),
        },
        {
          key: "national-workshops",
          icon: "shapes",
          labelKey: "title.national-workshops",
          to: RouteUtils.gestionnaireNationalWorkshops,
          visible: hasPermission.value("change_template_activity"),
        },
      ],
    },
    {
      key: "gestion-access",
      titleKey: "label.gestion.section.access",
      items: [
        {
          key: "fonction-assignments",
          icon: "user-shield",
          labelKey: "title.fonction-assignments",
          to: RouteUtils.gestionnaireFonctionAssignments,
          visible:
            hasPermission.value("view_all_userstructurefonction") ||
            hasPermission.value("view_scope_userstructurefonction"),
        },
      ],
    },
  ]);
  return sections;
};

/** Première page de gestion accessible (`null` : aucune). */
export const useGestionHome = () => {
  const sections = useGestionSections();
  return computed(
    () =>
      sections.value
        .flatMap((section) => section.items)
        .find((item) => item.visible !== false)?.to ?? null,
  );
};
